// extracted by mini-css-extract-plugin
module.exports = {"dialog":"login-dialog_dialog__6bhFz","closeButton":"login-dialog_closeButton__jbMKq"};